import {
  GENERATE_SUMMARY,
  GENERATE_SUMMARY_FAILURE,
  GET_SUMMARY_FAILURE,
  GENERATE_SUMMARY_SUCCESS,
  GET_SUMMARIES,
  RESET_ERROR,
  SET_SUMMARIES
} from "./actionTypes";

const initialState = {
  dataSummaries:null,
  generate_summary: {
    error: false,
    messageError: null,
    loading: false,
    loadingGetSummaries: false,
    success: false,
  },
};

const Summarization = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUMMARY_FAILURE:
      state = {
        ...state,
        generate_summary: {
          error: true,
          messageError: action.payload.error,
          loading: false,
          success: false,
        },
      };
      break;
    case GENERATE_SUMMARY:
      state = {
        ...state,
        generate_summary: {
          error: false,
          messageError: null,
          loading: true,
          loadingGetSummaries: false,
          success: false,
        },
      };
      break;
    case GENERATE_SUMMARY_SUCCESS:
      state = {
        ...state,
        generate_summary: {
          error: false,
          messageError: null,
          loading: false,
          success: true,
        },
      };
      break;
    case GENERATE_SUMMARY_FAILURE:
      state = {
        ...state,
        generate_summary: {
          error: true,
          messageError: action.payload.error,
          loading: false,
          success: false,
        },
      };
      break;
    case GET_SUMMARIES:
    state = {
      ...state,
      dataSummaries:null,
      generate_summary: {
        error: false,
        messageError: null,
        loading: true,
        loadingGetSummaries: true,
        success: false,
      },
    };
    break;
    case SET_SUMMARIES:
      state = {
        ...state,
        dataSummaries: action.payload,
        generate_summary: {
          error: false,
          messageError: null,
          loading: false,
          loadingGetSummaries: false,
          success: false,
        },
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        generate_summary: {
          error: false,
          messageError: null,
          loading: false,
          success: false,
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default Summarization;
